<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="had_status"
      placeholder="输入校准状态进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="gotoView(item)"
      >
        <div class="weui-cell__bd">
          <p>{{dateFormat(item.had_time, "yyyy-MM-dd")}}</p>
          <!-- <p class="list-item-muted">{{item.ha_yearmonth}}</p> -->
        </div>
        <div class="weui-cell__ft">
          <p>{{item.had_status}}</p>
          <!-- <span
            class="list-item-status"
            :class="{'warning':item.co_status!='已审核'}"
          >{{item.ha_yearmonth}}</span> -->
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}天</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/hr/hrAttendanceDay/list",
      filters: [
        {
          type: "period",
          name: "had_yearmonth"
        }
      ]
    };
  },
  created() {
    let had_emid = this.$route.query.had_emid
    this.otherCondition = [{
      type: "condition",
      value: `had_emid=${had_emid}`
    }]
  },
  methods: {
    gotoView(item) {
      this.$router.push({
        name: "OaAttendanceDay",
        params: {
          initData: Object.assign({}, item),
        },
      });
    },
  }
};
</script>